import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPricingData } from '../../../utils/pricingStorage';

const popularModels = ['iPhone 16 Pro Max', 'iPhone 15', 'Samsung S25 Ultra', 'MacBook Air M2'];

export default function PricingPreview() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/pricing?q=${encodeURIComponent(query.trim())}`);
    } else {
      navigate('/pricing');
    }
  };

  const handleQuickSearch = (model: string) => {
    navigate(`/pricing?q=${encodeURIComponent(model)}`);
  };

  return (
    <section className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 text-orange-400 text-sm font-medium mb-4">
              <span className="w-8 h-px bg-orange-400" />
              線上報價查詢
            </div>
            <h2 className="text-4xl font-bold text-white mb-6">
              輸入型號<br />
              <span className="text-orange-400">即時獲得報價</span>
            </h2>
            <p className="text-gray-400 leading-relaxed mb-8">
              輸入您的裝置型號，立即查看維修費用與預估時間。超過 40 種型號報價，透明公開，無隱藏收費。
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { num: '40+', label: '支援型號' },
                { num: '透明', label: '費用公開' },
                { num: '即時', label: '查詢結果' },
                { num: '0', label: '隱藏收費' },
              ].map((s) => (
                <div key={s.label} className="bg-gray-800 rounded-xl p-4">
                  <div className="text-2xl font-bold text-orange-400 mb-1">{s.num}</div>
                  <div className="text-gray-400 text-sm">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Search */}
          <div className="bg-gray-800 rounded-2xl p-8">
            <h3 className="text-white font-bold text-xl mb-6">快速報價查詢</h3>

            <form onSubmit={handleSearch} className="mb-6">
              <div className="relative flex items-center bg-gray-700 rounded-xl overflow-hidden">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-search-line text-gray-400 text-lg" />
                </div>
                <input
                  type="text"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="輸入型號，如：iPhone 16 Pro..."
                  className="flex-1 bg-transparent text-white placeholder-gray-400 text-sm py-3 pr-4 outline-none"
                />
                <button
                  type="submit"
                  className="m-1.5 px-5 py-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                >
                  查詢
                </button>
              </div>
            </form>

            <div>
              <p className="text-gray-400 text-xs mb-3">熱門搜尋</p>
              <div className="flex flex-wrap gap-2">
                {popularModels.map((m) => (
                  <button
                    key={m}
                    onClick={() => handleQuickSearch(m)}
                    className="px-3 py-1.5 bg-gray-700 hover:bg-orange-500/20 border border-gray-600 hover:border-orange-500/50 text-gray-300 hover:text-orange-400 text-xs rounded-full transition-all cursor-pointer whitespace-nowrap"
                  >
                    {m}
                  </button>
                ))}
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-700">
              <button
                onClick={() => navigate('/pricing')}
                className="w-full py-3 border border-gray-600 hover:border-orange-500 text-gray-400 hover:text-orange-400 text-sm rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                查看完整價目表 →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
